module.exports = __webpack_public_path__ + "main/assets/public/player-controls/skip-forwards-icon.fd36c3e8583cb7c3.svg";